// MWN-191 Hautberatung nav click trigger, loaded from ablyft-init.liquid when settings.hautberatung_ab_testing_enable is on
// Triggered experiment: visitors are bucketed only when they click the "Hautberatung" nav link (desktop + mobile).
// ABLyft page "hautberatung-click" is API activation
// variation code sets the target:
//   A: window.mwn191TargetUrl = '';  (empty = keeps the original menu link)
//   B: window.mwn191TargetUrl = 'https://quiz.mellownoir.com/';

const PAGE_API_NAME = 'hautberatung-click';
const LINK_SELECTOR = 'a[href*="hautberatung.mellownoir.com"]';
const ACTIVATION_TIMEOUT_MS = 1000;
const QUEUE_FLUSH_TIMEOUT_MS = 1500;
const POLL_INTERVAL_MS = 50;
const ABLYFT_QUEUE_KEY = 'ablyftQueue';
//set true for debugging
const DEBUG = true;

function isNewTabClick(event) {
	return event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0;
}

function waitFor(condition, timeoutMs) {
	const start = Date.now();

	return new Promise((resolve) => {
		const check = () => {
			if (condition()) {
				resolve(true);
				return;
			}
			if (Date.now() - start >= timeoutMs) {
				resolve(false);
				return;
			}
			setTimeout(check, POLL_INTERVAL_MS);
		};

		check();
	});
}
function hasVariationTarget() {
	return typeof window.mwn191TargetUrl === 'string';
}

// empty queue = bucketing sent to ABLyft, can redirect
function isAblyftQueueEmpty() {
	try {
		const queue = window.localStorage.getItem(ABLYFT_QUEUE_KEY);
		return !queue || queue === '[]' || queue === '{}';
	} catch (error) {
		return true;
	}
}

function navigate(url, details) {
	if (DEBUG) console.log('[MWN-191] redirect', url, details, window.ablyft.get?.('activeExperimentIds'));
	window.location.assign(url);
}

async function activateAndNavigate(originalUrl) {
	window.ablyft = window.ablyft || [];
	window.ablyft.push({ eventType: 'activatePage', pageApiName: PAGE_API_NAME });

	const isActivated = await waitFor(hasVariationTarget, ACTIVATION_TIMEOUT_MS);
	if (!isActivated) {
		navigate(originalUrl, { isActivated });
		return;
	}

	const isQueueFlushed = await waitFor(isAblyftQueueEmpty, QUEUE_FLUSH_TIMEOUT_MS);
	navigate(window.mwn191TargetUrl || originalUrl, { isActivated, isQueueFlushed });
}

function onHautberatungClick(event) {
	if (!(event.target instanceof Element)) return;

	const link = event.target.closest(LINK_SELECTOR);
	if (!link || isNewTabClick(event)) return;

	// stop navigation so ABLyft can bucket before redirect
	event.preventDefault();
	if (DEBUG) console.log('[MWN-191] click caught', link.href);
	activateAndNavigate(link.href);
}

document.addEventListener('click', onHautberatungClick, true);

if (DEBUG) {
	console.log('[MWN-191] script loaded, matching links:', document.querySelectorAll(LINK_SELECTOR));
}
